// extracted by mini-css-extract-plugin
export default {"consignee":"consignee_consignee__X6RNQ","title":"consignee_title__edVZC","fields":"consignee_fields__oUev1","field":"consignee_field__zUDH7","buttons":"consignee_buttons__cxcSj"};